import produce from "immer";

export const Types = {
  OPEN_MODAL: "@auth/OPEN_MODAL",
  CLOSE_MODAL: "@auth/CLOSE_MODAL",
  SIGN_IN_REQUEST: "@auth/SIGN_IN_REQUEST",
  SIGN_IN_FAILURE: "@auth/SIGN_FAILURE",
  SIGN_IN_SUCCESS: "@auth/SIGN_IN_SUCCESS",
  ACCESS_CODE_REQUEST: "@auth/ACCESS_CODE_REQUEST",
  ACCESS_CODE_REQUEST_SUCCESS: "@auth/ACCESS_CODE_REQUEST_SUCCESS",
  ACCESS_CODE_REQUEST_FAILURE: "@auth/ACCESS_CODE_REQUEST_FAILURE",
  ACCESS_CODE_VERIFY_REQUEST: "@auth/ACCESS_CODE_VERIFY_REQUEST",
  RESET_ACCESS_CODE: "@auth/RESET_ACCESS_CODE",
  SIGN_OUT: "@auth/SIGN_OUT",
  REFRESH_TOKEN_REQUEST: "@auth/REFRESH_TOKEN_REQUEST",
  REFRESH_TOKEN_SUCCESS: "@auth/REFRESH_TOKEN_SUCCESS",
  DOMAIN_TOKEN_SUCCESS: "@auth/DOMAIN_TOKEN_SUCCESS",
  RESET_ERROR: "@auth/RESET_ERROR"
};

const INITIAL_STATE = {
  isOpen: false,
  signed: false, // determinado pela resposta de /me na inicialização
  loading: false,
  error: null,
  accessCodeSent: false,
  accessCodeMessage: null
};

export default function auth(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case Types.OPEN_MODAL: {
        draft.isOpen = true;
        break;
      }
      case Types.CLOSE_MODAL: {
        draft.isOpen = false;
        break;
      }
      case Types.SIGN_IN_REQUEST: {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case Types.SIGN_IN_SUCCESS: {
        draft.signed = true;
        draft.loading = false;
        draft.error = null;
        break;
      }
      case Types.ACCESS_CODE_REQUEST:
      case Types.ACCESS_CODE_VERIFY_REQUEST: {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case Types.ACCESS_CODE_REQUEST_SUCCESS: {
        draft.loading = false;
        draft.error = null;
        draft.accessCodeSent = true;
        draft.accessCodeMessage = action.payload.message;
        break;
      }
      case Types.ACCESS_CODE_REQUEST_FAILURE:
      case Types.SIGN_IN_FAILURE: {
        draft.loading = false;
        draft.error = action.payload.message;
        break;
      }
      case Types.RESET_ACCESS_CODE: {
        draft.loading = false;
        draft.error = null;
        draft.accessCodeSent = false;
        draft.accessCodeMessage = null;
        break;
      }
      case Types.SIGN_OUT: {
        draft.signed = false;
        draft.loading = false;
        break;
      }
      case Types.RESET_ERROR: {
        draft.error = null;
        draft.loading = false;
        break;
      }
      case Types.REFRESH_TOKEN_REQUEST: {
        draft.loading = true;
        break;
      }
      case Types.REFRESH_TOKEN_SUCCESS: {
        draft.signed = true;
        draft.loading = false;
        draft.error = null;
        break;
      }
      case Types.DOMAIN_TOKEN_SUCCESS: {
        draft.error = null;
        break;
      }
      case "@user/GET_ACCOUNT_SUCCESS": {
        draft.signed = true;
        break;
      }
      case "@user/GET_ACCOUNT_FAILURE": {
        draft.signed = false;
        break;
      }
      default:
    }
  });
}

export const Creators = {
  openModal: () => ({
    type: Types.OPEN_MODAL
  }),

  resetError: () => ({
    type: Types.RESET_ERROR
  }),

  closeModal: () => ({
    type: Types.CLOSE_MODAL
  }),

  signInRequest: (email, senha, redirectCheckout = false) => ({
    type: Types.SIGN_IN_REQUEST,
    payload: { email, senha, redirectCheckout }
  }),

  requestAccessCode: identifier => ({
    type: Types.ACCESS_CODE_REQUEST,
    payload: { identifier }
  }),

  requestAccessCodeSuccess: message => ({
    type: Types.ACCESS_CODE_REQUEST_SUCCESS,
    payload: { message }
  }),

  accessCodeFailure: message => ({
    type: Types.ACCESS_CODE_REQUEST_FAILURE,
    payload: { message }
  }),

  verifyAccessCode: (identifier, code, redirectCheckout = false) => ({
    type: Types.ACCESS_CODE_VERIFY_REQUEST,
    payload: { identifier, code, redirectCheckout }
  }),

  resetAccessCode: () => ({ type: Types.RESET_ACCESS_CODE }),

  signFailure: message => ({
    type: Types.SIGN_IN_FAILURE,
    payload: { message }
  }),

  signInSuccess: (user) => ({
    type: Types.SIGN_IN_SUCCESS,
    payload: { user }
  }),

  signOut: (navigate) => ({
    type: Types.SIGN_OUT,
    payload: { navigate }
  }),

  refreshTokenSuccess: () => ({
    type: Types.REFRESH_TOKEN_SUCCESS
  }),

  setDomainTokenSuccess: () => ({
    type: Types.DOMAIN_TOKEN_SUCCESS
  })
};
